import React from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import {connect} from 'react-redux';
import {replaceSpace, setWindowLocationHash} from '../../../../../../src/libs/common-library';
import {getFirstLevelKey, getSecondLevelKey, getThirdLevelKey} from '../../../reducers/examples-reducer';
import CybsIcon from '@cybs-ui/components/lib/icon'
import { putDataInDevCenterDataStore } from '../../../../../app/store';

/**
 * 
 * Parameter description class 
 */
var pathParams = [];
var queryParams = [];
var headerParams = [];
var urlHash = "";
class ParameterDescriptions extends React.Component{
   
    render(){

          var type = this.props.type;
          var src = this.props.src;
          var headingPadding = (src=="request")?"10px":"0px";
          var parameterArray = [];
          if(type == 'Query')
          {
            parameterArray = this.props.queryParams;
          }
          else if(type == 'Header')
          {
            parameterArray = this.props.headerParams;
          }
          else
          {
            parameterArray = this.props.pathParams;
          }
            return (
                <div class = {type.toLowerCase()+"ParametersDescription-"+src}>
                    <div class = {type.toLowerCase()+"ParamaterHeader"} style = {{marginLeft: headingPadding, fontWeight: "bold", marginBottom: "15px"}}> {type + " Parameters"} </div>
                    <div className="parameterList" style={{ marginLeft: '20px'}}>
                  {parameterArray && parameterArray.map(comment =>
                    <div key={comment.name} id={src + "-" + comment.name} style={{margin:'5px'}}>
                     
                      <span id={"span-show-"+src + "-" + comment.name} class = 'descriptionsLabel' tabindex="1" onClick={() => {
                      urlHash = replaceSpace(getFirstLevelKey()).replaceAll("_","-") +"_" + replaceSpace(getSecondLevelKey()).replaceAll("_","-") +"_"+ replaceSpace(getThirdLevelKey()).replaceAll("_","-")+"_" + "requestfielddescription_" + comment.name.replaceAll("_","-");
                      setWindowLocationHash(urlHash);
                      }} style={{fontWeight:'bold', cursor:'pointer'}}>{comment.name}</span>
                      {comment.additionalInformation && <span onClick={() => {
                           putDataInDevCenterDataStore({type: 'UPDATE_NODE_CLICK_CHECK', nodeClickCheck: true})
                           putDataInDevCenterDataStore({type: 'UPDATE_CLICKED_NODE', clickedNode: 'request-'+ type+'-'+comment.name.replaceAll('-','!')})
                        }}><CybsIcon name='info' resolution='tiny' dataTest='info'/></span>}
                      <span style={{marginLeft: '10px'}}>{comment.type}</span>
                      {
                          comment.required &&
                          <span style={{marginLeft:'10px'}}><span style={{fontWeight:'bold', color:'red'}}>Required</span></span>
                      }
                      {
                          comment.description &&
                          <span dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(marked(comment.description))}}></span>
                      }
                    </div>
                  )}
                </div>
                </div>
            )              
    }
}

function mapStateToProps(state){

  pathParams = (state.rhsReducer.pathParameters == undefined) ? []: state.rhsReducer.pathParameters;
  queryParams = (state.rhsReducer.queryParameters == undefined) ? []: state.rhsReducer.queryParameters;
  headerParams = (state.rhsReducer.headerParameters == undefined) ? []: state.rhsReducer.headerParameters;
  return{
    queryParams: queryParams,
    pathParams: pathParams,
    headerParams : headerParams
  }
}

export default connect(mapStateToProps)(ParameterDescriptions);
